import React from 'react';
import PropTypes from 'prop-types';

class Button extends React.PureComponent {
  render() {
    const Icon = (
      <div>
        {this.props.icon &&
        <span className="book-btn-l">
          <i className={`fa ${this.props.icon}`} />
        </span>
        }
        <span className="book-btn-r">{this.props.value}</span>
        <div className="clear" />
      </div>
    );
    if (this.props.type === 'link') {
      return (
        <a href={this.props.url} target={this.props.blank ? '_blank' : '_self'} className={`book-btn ${this.props.className}`}>
          {Icon}
        </a>
      );
    }
    return (
      <button className={`book-btn ${this.props.className}`} onClick={this.props.onClick}>
        {Icon}
      </button>
    );
  }
}

Button.propTypes = {
  type: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  blank: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  type: 'button',
  url: '',
  icon: '',
  value: '',
  className: '',
  blank: false,
  onClick: () => {},
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js